/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import UserConstants from 'constants/UserConstants';
import preferences from 'Preferences';
// @ts-expect-error
import CheckmarkBullet from 'start/CheckmarkBullet';
import EntityStore from 'stores/EntityStore';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import * as ModalContainer from 'ui-library/ModalContainer';
import Modal from 'ui-library/modals/Modal';
import SectionTabs from 'ui-library/SectionTabs';
import licenses from 'user/Licenses';

import * as StartActions from '../StartActions';
import {DEMO_TYPE} from '../StartConstants';
import {StartPreferences} from '../StartConstants';
// @ts-expect-error
import * as EnterpriseFeatures from './EnterpriseFeatures';

export const ENTERPRISE_FEATURES_KEYS = {
  REGISTRY: 'REGISTRY',
  SAMPLE_TRACKING: 'SAMPLING_TRACKING',
  WORKFLOWS: 'WORKFLOWS',
  REQUESTS: 'REQUESTS',
  REVIEWS: 'REVIEWS',
  BULK_MOLECULAR_BIOLOGY: 'BULK_MOLECULAR_BIOLOGY',
};

const ENTERPRISE_FEATURES = {
  [ENTERPRISE_FEATURES_KEYS.REGISTRY]: {
    title: 'Bioregistry',
    componentClass: EnterpriseFeatures.Registry,
  },
  [ENTERPRISE_FEATURES_KEYS.SAMPLE_TRACKING]: {
    title: 'Sample Tracking',
    componentClass: EnterpriseFeatures.SampleTracking,
  },
  [ENTERPRISE_FEATURES_KEYS.WORKFLOWS]: {
    title: 'Workflows',
    componentClass: EnterpriseFeatures.Workflows,
  },
  [ENTERPRISE_FEATURES_KEYS.REQUESTS]: {
    title: 'Requests',
    componentClass: EnterpriseFeatures.Requests,
  },
  [ENTERPRISE_FEATURES_KEYS.REVIEWS]: {
    title: 'Witness & Review',
    componentClass: EnterpriseFeatures.Reviews,
  },
  [ENTERPRISE_FEATURES_KEYS.BULK_MOLECULAR_BIOLOGY]: {
    title: 'Bulk Molecular Bio',
    componentClass: EnterpriseFeatures.BulkMolecularBiology,
  },
};

interface Props {
  initialTab: string;
  onRequestClose: (...args: Array<any>) => any;
}

type State = any;

class UpgradeAccountModal extends React.Component<Props, State> {
  static open(initialTab: any): void {
    ModalContainer.open(
      UpgradeAccountModal,
      /* eslint-disable-next-line @typescript-eslint/unbound-method */
      <UpgradeAccountModal onRequestClose={UpgradeAccountModal.close} initialTab={initialTab} />
    );
  }

  static close(): void {
    ModalContainer.close(UpgradeAccountModal);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  static hasRequested() {
    return preferences.get(`${StartPreferences.REQUESTED_DEMO_NAMESPACE}${DEMO_TYPE.ENTERPRISE_DEMO_IN_APP}`);
  }

  static isEnabled(user?: any): boolean {
    user = user || EntityStore.currentUser();
    return (
      user &&
      !licenses.hasEnterprisePlan() &&
      !user.institution?.licensed &&
      (user.proclaimed === UserConstants.PROCLAIMED_COMMERCIAL ||
        user.proclaimed === UserConstants.PROCLAIMED_NONPROFIT)
    );
  }

  static defaultProps = {
    initialTab: ENTERPRISE_FEATURES_KEYS.WORKFLOWS,
  };

  state: State = {
    activeTab: this.props.initialTab,
  };

  _handleClick = (): void => {
    StartActions.requestDemoFromProduct(DEMO_TYPE.ENTERPRISE_DEMO_IN_APP);
    this.props.onRequestClose();
  };

  _handleSelectTab = (tab: any): void => {
    this.setState({activeTab: tab});
  };

  render(): JSX.Element {
    const ActiveEnterpriseFeatureClass = ENTERPRISE_FEATURES[this.state.activeTab].componentClass;
    return (
      <Modal large={true} onRequestClose={this.props.onRequestClose} suppressHeader={true}>
        <BenchlingIcon className="close" icon="close" data-dismiss="modal" />
        <div className="referralModal-title">Upgrade to Benchling Enterprise</div>
        <SectionTabs
          className="referralModal-sectionTabs"
          tabs={Object.values(ENTERPRISE_FEATURES_KEYS).map((key, index) => ({
            handleClick: () => {
              this._handleSelectTab(key);
            },
            isActive: this.state.activeTab === key,
            text: ENTERPRISE_FEATURES[key].title,
          }))}
        />
        <Row className="referralModal-imageContainer">
          <Col md={10} md-offset={1}>
            <ActiveEnterpriseFeatureClass />
          </Col>
        </Row>
        <Row className="referralModal-infoContainer">
          <Col md={3} md-offset={1} className="referralModal-description">
            <strong className="legacy-font-proxima-17">Benchling Enterprise</strong>
            <div>
              is the first modern software platform built for biologics R&D teams. It combines novel
              functionality with the compliance and security you need to file for IND quickly.
            </div>
          </Col>
          <Col md={7}>
            {[
              "Access to all of Benchling's functionality: Workflow Management, " +
                'Sample Tracking, bulk Molecular Biology tools, and witnessing and review',
              'Dedicated 24/7 account managers, data import and implementation services, ' +
                'and onsite training sessions',
              'Dedicated deployment for enterprise-grade security of IP',
              'Special pricing for teams under 10 scientists',
            ].map((text, i) => (
              <CheckmarkBullet className="checkmarkBullet--compact" isGreen={true} text={text} key={i} />
            ))}
          </Col>
        </Row>
        <div className="u-text-align-right u-spacing-top">
          <Button
            buttonStyle={ButtonStyle.PRIMARY}
            onClick={this._handleClick}
            size={ButtonSize.LARGE}
            disabled={UpgradeAccountModal.hasRequested()}
            text={
              UpgradeAccountModal.hasRequested()
                ? 'Information Requested'
                : 'Request a Benchling Enterprise Demo'
            }
          />
        </div>
      </Modal>
    );
  }
}

export default UpgradeAccountModal;
